const Hero = ({ isMobile, data }) => (
  <div
    style={{
      backgroundImage: `url(${
        isMobile ? data?.imageMobile : data?.imageDesktop
      })`,
    }}
    className="h-130 bg-no-repeat bg-top bg-cover flex flex-col justify-center items-center relative -top-20 md:top-0 lg:-top-6 xl:-top-12"
  ></div>
);

export default Hero;
